import { useReducer } from "react";
export var useRerender = function () {
    return useReducer(function () { return +new Date(); }, 0)[1];
};
